import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  useHistory
} from 'react-router-dom';

import {
  VContainer
} from '@vodacom/web-common';

import {
  withScreenViewTagging
} from 'hocs';

import {
  CustomColors,
  Icons
} from 'constants';

import {
  capitalizeFirstLetter,
  getStorageWithExpiry,
  useRedirectHandler
} from 'helpers';

import {
  SocialBundleScenarioCard
} from '.';

export const SocialBundleStateContainerUI = props => {

  const history = useHistory();

  const redirectHandler = useRedirectHandler();

  const onBuyDataBundle = () =>{

    props.onHandleUtagLinkEvent('activation unsuccessful: buy a bundle');

    history.push('/pillars/buy');
  };

  const onRedirectSocialMediaPage = () => {

    if (props.socialBundleType?.toLowerCase()  === 'facebook'){

      props.onHandleUtagLinkEvent(`bundle activated: go to ${ props.socialBundleType}`);

      redirectHandler(
        history.location,
        `/redirect?targetUrl=https://www.${props.socialBundleType}.com`,
        true
      );

      return;

    };
  };

  return (

    <VContainer
      width={'360px'}
      height={props.isBundleActivated ?'324px' : '385px'}
      minWidth={'320px'}
      color={CustomColors.Black5}
      boxShadow={`0px 5px 5px 0px ${CustomColors.TransparentBlack1}`}
      borderRadius={'4px'}>

        { props.isBundleActivated

          ? <SocialBundleScenarioCard
              isSuccess={true}
              message={`Your ${props.socialBundleType} bundle has been activated. You’ll also receive an SMS confirmation.`}
              buttonText={`Go to ${capitalizeFirstLetter(props.socialBundleType)}`}
              pageSection={`${props.socialBundleType}`}
              pageName= {`cbu: connectu: ${props.socialBundleType}: bundle activated`}
              tagViewData={{
                ...SocialBundleStateContainerUI.tagViewData,
                journey_event: 'journey_end',
                journey_step: `cbu: connectu: ${props.socialBundleType}: bundle activated`,
                journey_type: `${props.socialBundleType}`,
                journey_name: `cbu: ${props.socialBundleType}`
              }}
              onClick={onRedirectSocialMediaPage}/>

          : <SocialBundleScenarioCard
              isSuccess={false}
              icon={Icons.WarningCircle}
              color={CustomColors.Red1}
              title={'Activation Unsuccessful'}
              message={`To qualify for a FREE ${capitalizeFirstLetter(props.socialBundleType)}  data bundle you need to have: Recharged in the last 30 days -or- Previously bought at least one data bundle`}
              buttonText={'Buy a data bundle'}
              pageEvent={'page_error'}
              pageSection={`${props.socialBundleType}`}
              pageName= {`cbu: connectu: ${props.socialBundleType}: activation unsuccessful`}
              tagViewData={{
                ...SocialBundleStateContainerUI.tagViewData,
                error_message: props.errorMessage
              }}
              onClick={onBuyDataBundle}/>
          }

    </VContainer>
  );
};

SocialBundleStateContainerUI.propTypes = {
  isBundleActivated: PropTypes.bool,
  onHandleUtagLinkEvent: PropTypes.func,
  socialBundleType: PropTypes.string,
  errorMessage: PropTypes.string
};

SocialBundleStateContainerUI.pageName = 'cbu: connectu: facebook: activate my free bundle';

SocialBundleStateContainerUI.tagViewData = {
  visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
  visitor_type: 'consumer',
  visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
};

export const SocialBundleStateContainer = withScreenViewTagging(SocialBundleStateContainerUI);
